import { KnobCronComponent } from './../../../app-components/knob-cron/knob-cron.component';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ResgateConsultaService } from 'src/app/services/http/resgate-consulta.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-consulta',
  templateUrl: './card-consulta.component.html',
  styleUrls: ['./card-consulta.component.scss']
})
export class CardConsultaComponent implements OnInit {

  @Input() status:string = '';
  @Input() msg:string = '';
  @Input() token:string = '';
  @Input() titulo:string = 'CONSULTA';
  @Input() tipoConsulta:string = '';
  @Input() idConsulta:string | number = '';
  @Input() statusCodigoControle = {};
  @Input() msgCodigoControle = {};
  //@Input() consulta : any;
  @Output() update = new EventEmitter();
  @Input() codigoControle: any = '';

  atualizando = false;

  @Input() isConsultaReload:boolean = false;
  binestErro:boolean = false;

  //tempo para reconsultar - knob
  reloadStatus:boolean = false;
  dadosStorage: string = '';
  timeCron: number = 0;
  minutosAguardarConsulta: number = 2;
  //fim tempo para reconsultar - knob

  erroUf: boolean = false;

  constructor(private consultaService: ResgateConsultaService, private router: Router, private _knobCron: KnobCronComponent) { }

  ngOnInit() {}

  ngOnChanges() {
    this.erroUf = false;

    if(this.msg === 'ERRO_UF')
      this.erroUf = true;

    this.consultaService.atualizarStatusRecarregar.subscribe((e:boolean) =>{
      this.atualizando = e;
    })

    if(this.msg=='INFELIZMENTE A BASE DE DADOS DESTA INFORMAÇÃO ENCONTRA-SE INOPERANTE OU COM DIFICULDADES EM SUA TRANSMISSÃO, POR FAVOR AGUARDE ALGUNS MINUTOS E TENTE RECARREGAR NO BOTÃO AO LADO.'
          || this.msg=='CONSULTA EM ANDAMENTO, AGUARDE...')
      this.msg = '';


    this.statusCodigoControle = {
      'OK': 'success',
      'PARCIAL_OK': 'success',
      'SEMREGISTRO_OK': 'success',
      'SEMREGISTRO_NAOCOBRAR': 'success',
      'ERRO_FORNECEDOR': 'disabled',
      'PENDENTE': 'disabled',
      'CORTESIA': 'disabled',
      ...this.statusCodigoControle
    };

    this.msgCodigoControle = {
      'OK': '',
      'PARCIAL_OK': 'CHASSI PARCIALMENTE DECODIFICADO',
      'SEMREGISTRO_OK': 'NADA CONSTA',
      'SEMREGISTRO_NAOCOBRAR': 'NADA CONSTA',
      'ERRO_FORNECEDOR': 'INFELIZMENTE A BASE DE DADOS DESTA INFORMAÇÃO ENCONTRA-SE INOPERANTE OU COM DIFICULDADES EM SUA TRANSMISSÃO, POR FAVOR AGUARDE ALGUNS MINUTOS E TENTE RECARREGAR NO BOTÃO AO LADO.',
      'PENDENTE': 'CONSULTA EM ANDAMENTO, AGUARDE...',
      'CORTESIA': 'SEM DETALHAMENTO',
      ...this.msgCodigoControle
    };

    //CASO ERRO DE BLOCO CORTESIA, ESSA CONDICAO HABILITA O BOTAO DE RECONSULTAR
    if(this.codigoControle == 'CORTESIA'){
      this.codigoControle = 'ERRO_FORNECEDOR';
    }

    //CONSTRUIR RESPOSTA BINEST ERRO FORNECEDOR
    this.binestErro = (this.tipoConsulta == 'BIN_ESTADUAL' && this.codigoControle == 'ERRO_FORNECEDOR') ? true : false;


    if(this.codigoControle != 'PENDENTE' && this.codigoControle != 'ERRO_FORNECEDOR' && this.codigoControle != 'CORTESIA') {
      this.msg = this.msg || this.msgCodigoControle[this.codigoControle] || '';
      this.status = this.status || this.statusCodigoControle[this.codigoControle] || '';

    } else {
      this.msg = this.msgCodigoControle[this.codigoControle];
      this.status = this.statusCodigoControle[this.codigoControle];

    }

    // Tratamento das mensagens de erros de algumas consultas
    if((this.tipoConsulta == 'GRAVAME_SIMPLES' || this.tipoConsulta == 'DECODIFICADOR') && (this.codigoControle == 'ERRO_FORNECEDOR' || this.codigoControle == 'SEMREGISTRO_NAOCOBRAR')){
      this.msg = 'SEM DETALHAMENTO';
    }
    if(this.tipoConsulta == 'MOTOR' && this.codigoControle == 'PENDENTE'){
      this.msg = 'SEM DETALHAMENTO';
    }

    //tempo para reconsultar - knob
    if(this.tipoConsulta != null && this.tipoConsulta != ""){

      this.reloadStatus = this._knobCron.timeReconsulta(this.tipoConsulta, this.token);

      if(this.reloadStatus) {

        this._knobCron.outTime.subscribe((time:number) =>{
          this.timeCron = time;
          if(time >= 100){
            this._knobCron.removeDadosStorage(this.tipoConsulta, this.token);
            window.location.reload();
          }
        })

        this.codigoControle = 'PENDENTE';
        this.msg = 'ESTAMOS ATUALIZANDO A CONSULTA, FAVOR AGUARDAR.'
        this._knobCron.cronReload(this.minutosAguardarConsulta, this.tipoConsulta, this.token);
      }
    }
    //fim tempo para reconsultar - knob
  }

  atualizarConsulta() {
    //tempo para reconsultar - knob
    this._knobCron.insertDadosStorage(this.tipoConsulta, this.token);
    //fim tempo para reconsultar - knob
    this.atualizando = true;
    this.consultaService.atualizarStatus(true);
    this.consultaService.refazerConsulta(this.tipoConsulta, this.idConsulta)
    .then( r => this.update.emit(r) )
    .catch(()=>{
      this.consultaService.atualizarStatus(false);
      this.atualizando = false
    })
    .finally(() => {
      this.consultaService.atualizarStatus(false);
      this.atualizando = false
    } )
  }

}
